import IndexView from './IndexView';
import PrivacyView from './PrivacyView';
import TermsView from './TermsView/TermsView';
import AboutView from './AboutView';
import TechnologyView from './TechnologyView';
import NewsView from './NewsView';


const routes = [
    {
        path: '/',
        renderer: (params = {}) => <IndexView {...params} />,
    },
    {
        path: '/privacy',
        renderer: (params = {}) => <PrivacyView {...params} />,
    },
    {
        path: '/terms',
        renderer: (params = {}) => <TermsView {...params} />,
    },
    {
        path: '/about',
        renderer: (params = {}) => <AboutView {...params} />,
    },
    {
        path: '/technology',
        renderer: (params = {}) => <TechnologyView {...params} />,
    },
    {
        path: '/news',
        renderer: (params = {}) => <NewsView {...params} />,
    },
];

export default routes;